module.exports = __webpack_public_path__ + "img/schmiedeeisengitter.d539a182.jpg";